import EnterCodeView from "../views/EnterCodeView/EnterCodeView";
import CustomCardView from "../views/CustomCardView/CustomCardView";
import GiftCardFillerView from "../views/GiftCardFiller/GiftCardFillerView";
import GrunerlokkaBuyInstructionsView from "../views/InstructionsPage/GrunerlokkaBuyInstructionsView";
import GrunerlokkaPayInstructionsView from "../views/InstructionsPage/GrunerlokkaPayInstructionsView";
import ProductSelectionView from "../views/ProductSelectionView/ProductSelectionView";
import StartPage from "../views/StartPage/StartPage";
import ListView from "../views/ListView/ListView";

const pages = {
    startPage: {
        component: StartPage
    },
    productSelection: {
        component: ProductSelectionView
    },
    giftCardFiller: {
        component: GiftCardFillerView
    },
    grunerlokkaBuyInstructions: {
        component: GrunerlokkaBuyInstructionsView
    },
    sentrumBuyInstructions: {
        component: GrunerlokkaBuyInstructionsView
    },
    grunerlokkaPayInstructions: {
        component: GrunerlokkaPayInstructionsView
    },
    sentrumPayInstructions: {
        component: GrunerlokkaPayInstructionsView
    },
    enterCode: {
        component: EnterCodeView
    },
    customCard: {
        component: CustomCardView
    },
    list: {
        component: ListView
    }
}

export default pages;
